module.exports = __webpack_public_path__ + "static/img/receive-task.e1131038.svg";